// cleanup_convert_to_typescript_file_GENERICS

import { createUseStyles } from '@glu/theming';

const styles = {
  hidden: {
    display: 'none !important'
  },
  alignment: {
    '@media only screen and (max-width: 375px)': {
      width: 'auto'
    }
  },
  spinnerContainer: {
    overflow: 'hidden'
  }
};

export default createUseStyles(styles);
